import { render, staticRenderFns } from "./PackageElement.vue?vue&type=template&id=4a743c9c&"
import script from "./PackageElement.vue?vue&type=script&lang=js&"
export * from "./PackageElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports